import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * å¿çº§è¡æ¿åº
 */
@JsonObject
export class County {
  /**
   * æå±å¸çº§è¡æ¿åºId
   */
  @JsonProperty('cityId', Number)
  cityId: number = undefined;

  /**
   * å¿çº§è¡æ¿åºId
   */
  @JsonProperty('id', Number)
  id: number = undefined;

  /**
   * å¿çº§è¡æ¿åºåç§°
   */
  @JsonProperty('name', String)
  name: string = undefined;
}
